import { WORKSPACE_MENU_SECTIONS_CONFIG_URLS } from '@modules/workspaceSettings/constants';
import { Box, Stack } from '@mui/material';
import { ApprovedDomains } from '../ApprovedDomains';
import { FeedbackTranslation } from '../FeedbackTranslation';
import { SSOSettings } from '../SSOSettings';
import { TaxonomySettings } from '../TaxonomySettings';
import { Users } from '../Users';

interface WorkspaceSettingsMenuListParams {
  selectedWorkspaceSetting?: string;
}

export const WorkspaceSettingDetailView = ({
  selectedWorkspaceSetting = 'sso-settings',
}: WorkspaceSettingsMenuListParams) => {
  const getComponentForSetting = (setting: string) => {
    switch (setting) {
      case WORKSPACE_MENU_SECTIONS_CONFIG_URLS.SSO_SETTINGS:
        return <SSOSettings />;
      case WORKSPACE_MENU_SECTIONS_CONFIG_URLS.USERS_PERMISSIONS:
        return <Users />;
      case WORKSPACE_MENU_SECTIONS_CONFIG_URLS.APPROVED_DOMAINS:
        return <ApprovedDomains />;
      case WORKSPACE_MENU_SECTIONS_CONFIG_URLS.TAXONOMY_SETTINGS:
        return <TaxonomySettings />;
      case WORKSPACE_MENU_SECTIONS_CONFIG_URLS.FEEDBACK_TRANSLATIONS:
        return <FeedbackTranslation />;
      default:
        return <Box>Select a valid setting</Box>;
    }
  };

  return (
    <Stack
      width="100%"
      minWidth={0}
      sx={{
        pt: 3,
      }}
    >
      {selectedWorkspaceSetting ? (
        getComponentForSetting(selectedWorkspaceSetting)
      ) : (
        <Box>No Workspace Setting Selected</Box>
      )}
    </Stack>
  );
};
